import LaunchDarklyContext from '../contexts/LaunchDarkly/LaunchDarklyContext';
import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';

export default function useFlags() {
  return useLDFlags(LaunchDarklyContext);
}
